(() => {
  const initialize = async (root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const track = root.querySelector('[data-cookie-track]');
    const status = root.querySelector('[data-cookie-status]');

    try {
      const shop = window.Shopify?.shop || 'yvrcookie.myshopify.com';
      const response = await fetch(`/apps/archie/order/cookie-products?include_recent_sold_out=true&shop=${encodeURIComponent(shop)}`);
      if (!response.ok) throw new Error('Menu unavailable');
      const result = await response.json();
      const products = Array.isArray(result) ? result : result.products || [];
      const fragment = document.createDocumentFragment();

      products.forEach((product) => {
        const name = String(product.name || product.title || '');
        if (!name || /assorted/i.test(`${name} ${product.handle || ''}`)) return;
        const imageData = product.imageSrc || product.images?.[0] || product.image || product.featured_image || product.featuredImage;
        const source = typeof imageData === 'string' ? imageData : imageData?.src || imageData?.url || imageData?.originalSrc;
        if (!source) return;
        const imageUrl = new URL(source, window.location.origin);
        if (!['https:', 'http:'].includes(imageUrl.protocol)) return;
        imageUrl.searchParams.set('width', '400');
        const figure = document.createElement('figure');
        const image = document.createElement('img');
        image.src = imageUrl.href;
        image.alt = name;
        image.width = 400;
        image.height = 400;
        image.loading = 'lazy';
        image.decoding = 'async';
        const caption = document.createElement('figcaption');
        caption.textContent = name;
        if (product.availabilityStatus === 'sold-out') {
          const soldOut = document.createElement('small');
          soldOut.textContent = 'Sold out';
          caption.append(soldOut);
        }
        figure.append(image, caption);
        fragment.append(figure);
      });

      if (!fragment.childElementCount) throw new Error('No flavours');
      track.replaceChildren(fragment);
      track.hidden = false;
      status.hidden = true;
      const stopSwipeCue = () => {
        if (Math.abs(track.scrollLeft) < 2) return;
        root.dataset.menuExplored = 'true';
        track.removeEventListener('scroll', stopSwipeCue);
      };
      track.addEventListener('scroll', stopSwipeCue, { passive: true });
    } catch {
      status.textContent = 'The flavours could not be loaded. Please try again shortly.';
    }
  };

  const initializeWithin = (scope) => scope.querySelectorAll('[data-holiday-cookie-carousel]').forEach(initialize);
  initializeWithin(document);
  document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
})();
